<script setup lang="ts">
import { ref } from 'vue';

import Logo from '@/assets/Apexx_LOGO.webp';
import { useRouter } from 'vue-router';

const router = useRouter();
import {
	Button,
	Card,
	Icon,
	List,
	TopBar,
	Typography,
} from '@apexx/component-library';
import { motion } from 'motion-v';

;
const items = [
	{
		id: 1,
		title: 'Maximum Recovery & Minimum Payback Time',
		description: 'Apexx delivers advanced, efficient and',
		content:
			'When it comes to gold mining operations, recovery is a crucial factor to be considered. APEXX with its advanced, efficient and sustainable technology will assist you to maximize your recovery which in turn will lead to minimizing the payback time. To acheive maximum recovery, miners need to use efficient extraction techniques and equipments, while minimising the loss of gold. APEXX has the best mining equipments and consultancy services to make your gold mining operations more profitable, sustainable and successful in long term.',
		icon: 'trending_up' as const,
	},
	{
		id: 2,
		title: 'Global presence',
		description:
			'APEXX has a strong global presence in the gold mining industry',
		content:
			'APEXX has a global presence in gold mining industry, with operations in several countries across the world. The company has a diverse portfolio of assets that span from West African countries to Central and South African countries, South America, Russia etc. The company’s global footprint enables it to leverage its technical expertise and operational excellence to unlock value from its assets and create long-term sustainable growth. APEXX’s reliable technology and competitive prices has provided it a competitive advantage in the mining industry and facilitated its global reach. APEXX is well-positioned to continue to grow and deliver value to its stakeholders.',
		icon: 'global' as const,
	},
	{
		id: 3,
		title: 'Integrated Solutions',
		description:
			'With over 25 years of experience in the gold mining industry',
		content:
			'The company has more than 25 years of experience as Solutions Providers in the Gold Mining Industry. APEXX knows that Integrated Solutions are becoming increasingly important in gold mining operations to improve efficiency, productivity, and sustainability. Integrated solutions refers to a comprehensive approach to manage all aspects of mining process, from exploration and extraction to processing, waste management and environmental protection. By adopting an integrated approach, miners can optimize the entire value chain and ensure that all processes are aligned and working together seamlessly. This can lead to significant improvements in productivity, safety and cost-effectiveness.',
		icon: 'blocks' as const,
	},
	{
		id: 4,
		title: 'Mastering in reducing water consumption',
		description: 'Apexx leads the way in reducing water consumption',
		content:
			'Water is an indispensable part of our life and conserving it has become our responsibility and APEXX has been leading the way in this regard by mastering the art of reducing water consumption for any gold mining operation. By implementing various innovative and sustainable practices, the company has been able to significantly reduce its water consumption during the mining process. By prioritising water conservation and sustainability, APEXX is setting an example for the mining industry and demonstrating that responsible resource extraction is possible without compromising the environment.',
		icon: 'drop' as const,
	},
];

const showNext = ref(false);

const scrollToTop = async () => {
	// await new Promise((resolve) => setTimeout(resolve, 100));
	window.scrollTo({ top: 0, behavior: 'instant' });
};

const gotoNext = () => {
	showNext.value = true;
	scrollToTop();
};

const gotoBack = () => {
	showNext.value = false;
	scrollToTop();
};

const selectedItem = ref<any | null>(null);

const viewItem = (item: any) => {
	selectedItem.value = item;
	scrollToTop();
};

const closeItem = () => {
	selectedItem.value = null;
	scrollToTop();
};

const handleBack = () => {
	if (selectedItem.value) {
		closeItem();
	} else {
		gotoBack();
	}
};

const gotoLogin = () => {
	router.push({ name: 'login' });
};

/* w-1/5 w-3/5 */
</script>

<template>
	<div
		v-if="!showNext"
		class="flex min-h-screen w-full flex-col bg-primary/5"
		style="padding-bottom: var(--safe-area-bottom)"
	>
		<TopBar
			class="bg-primary"
			img-class="h-14"
			:show-image="true"
			:img="Logo"
		>
			<template #trailing>
				<Icon
					name="login"
					class="text-surface"
					size="md"
					@click="gotoLogin"
				/>
			</template>
		</TopBar>
		<main class="flex flex-1 flex-col">
			<div
				class="mx-auto my-8 flex w-full max-w-4xl flex-col gap-8 px-6 md:my-12 md:gap-10 md:px-8"
			>
				<div
					class="mx-auto flex flex-col flex-wrap items-end justify-center gap-1 uppercase md:gap-2"
				>
					<div class="flex gap-2">
						<Icon
							name="invertedCommas"
							size="lg"
							class="rotate-180 text-primary"
						/>
						<Typography
							variant="title"
							class="text-on-surface-muted tracking-wider"
						>
							Solutions for
							<span class="text-2xl">successful</span>
						</Typography>
					</div>
					<span
						class="text-5xl font-semibold text-primary md:text-6xl lg:text-7xl"
						>Gold Mining</span
					>
					<div class="flex gap-2">
						<Typography
							variant="title"
							class="text-on-surface-muted tracking-widest"
							>Operations
						</Typography>
						<Icon
							name="invertedCommas"
							size="lg"
							class="mt-1 text-primary"
						/>
					</div>
				</div>
				<div class="border-l-2 border-primary py-1 pl-4">
					<Typography
						variant="body"
						class="text-justify leading-6 tracking-widest text-on-surface-muted italic md:text-lg md:leading-7"
					>
						End-to-End mining solutions engineered for small and
						medium scale gold miners - from Washing Plants to
						commissioning, across alluvial and hard rock operations.
					</Typography>
				</div>
				<div
					class="mx-auto grid w-full max-w-2xl grid-cols-4 justify-items-center gap-3 md:gap-6"
				>
					<div
						class="flex aspect-square w-full max-w-24 flex-col items-center justify-center rounded-lg border border-border bg-white"
					>
						<span class="text-xl font-bold text-primary md:text-2xl"
							>29+</span
						>
						<Typography
							variant="caption"
							class="text-on-surface-muted"
							>Years</Typography
						>
					</div>
					<div
						class="flex aspect-square w-full max-w-24 flex-col items-center justify-center rounded-lg border border-border bg-white"
					>
						<span class="text-xl font-bold text-primary md:text-2xl"
							>20+</span
						>
						<Typography
							variant="caption"
							class="text-on-surface-muted"
							>Countries</Typography
						>
					</div>
					<div
						class="flex aspect-square w-full max-w-24 flex-col items-center justify-center rounded-lg border border-border bg-white"
					>
						<span class="text-xl font-bold text-primary md:text-2xl"
							>4</span
						>
						<Typography
							variant="caption"
							class="text-on-surface-muted"
							>Continents</Typography
						>
					</div>
					<div
						class="flex aspect-square w-full max-w-24 flex-col items-center justify-center rounded-lg border border-border bg-white"
					>
						<span class="text-xl font-bold text-primary md:text-2xl"
							>500</span
						>
						<Typography
							variant="caption"
							class="text-on-surface-muted"
							>TPH Max</Typography
						>
					</div>
				</div>
				<div>
					<Typography
						variant="body"
						class="uppercase text-primary/60 tracking-wider"
						>Our solutions
					</Typography>
					<motion.div
						:initial="{ opacity: 0, y: 10 }"
						:animate="{ opacity: 1, y: 0 }"
						:transition="{ duration: 0.3 }"
						class="w-full flex flex-col gap-4 mt-3"
					>
						<div class="flex gap-3 w-full">
							<Button
								:full-width="true"
								variant="light"
								class="bg-white border border-border"
								icon="shovel"
							>
								<Typography class="text-on-surface-muted"
									>Alluvial Mining</Typography
								>
							</Button>
							<Button
								:full-width="true"
								variant="light"
								class="bg-white border border-border"
								icon="hammer"
							>
								<Typography class="text-on-surface-muted"
									>Hard Rock Mining</Typography
								>
							</Button>
						</div>
						<div class="flex gap-3 w-full">
							<Button
								:full-width="true"
								variant="light"
								class="bg-white border border-border"
								icon="flask"
							>
								<Typography class="text-on-surface-muted"
									>Fire Assay Lab</Typography
								>
							</Button>
							<Button
								:full-width="true"
								variant="light"
								class="bg-white border border-border"
								icon="users"
							>
								<Typography class="text-on-surface-muted"
									>Tech Consultancy</Typography
								>
							</Button>
						</div>

						<Button
							:full-width="true"
							variant="light"
							class="bg-white border border-border"
							icon="settings"
						>
							<Typography class="text-on-surface-muted"
								>Engineering, procurement &
								Commissioning</Typography
							>
						</Button>
					</motion.div>
					<div class="flex mt-10">
						<Button
							@click.prevent="gotoNext"
							variant="outline"
							icon-right="arrowRight"
							class="ml-auto cursor-pointer border-primary text-primary"
							>Next</Button
						>
					</div>
				</div>
			</div>
		</main>
	</div>
	<motion.div
		v-else
		:initial="{ opacity: 0, x: 20 }"
		:animate="{ opacity: 1, x: 0 }"
		:transition="{ duration: 0.3 }"
		class="relative flex min-h-screen w-full flex-col bg-primary/5"
		style="padding-bottom: var(--safe-area-bottom)"
	>
		<TopBar
			class="bg-primary text-surface"
			img-class="h-14"
			:show-back="true"
			:show-image="true"
			:img="Logo"
			@back="handleBack"
		>
			<template #trailing>
				<Icon
					name="login"
					class="text-surface"
					size="md"
					@click="gotoLogin"
				/>
			</template>
		</TopBar>
		<main class="flex-1 flex flex-col h-full">
			<div :transition="{ duration: 0.5 }" class="bg-primary w-full py-3">
				<div
					class="mx-auto max-w-3xl flex items-center gap-2 px-5 py-5"
				>
					<Typography
						variant="display"
						class="text-white font-semibold leading-11 tracking-wider uppercase"
					>
						Why <span class="text-amber-400">Apexx</span>
					</Typography>
					<span class="text-white italic border-l-2 border-white pl-4"
						>“Your mining site is unique and so is every solution we
						design. APEXX has spent nearly three decades refining
						the art of making gold recovery efficient, profitable,
						and responsible — whatever the geography."</span
					>
				</div>
			</div>

			<div
				v-if="!selectedItem"
				class="mx-auto flex h-full w-full max-w-3xl flex-1 flex-col px-5 py-5 md:px-8 md:py-8"
			>
				<List
					@select="viewItem"
					:items="items"
					custom-class="h-auto p-3 border border-primary/20 bg-white"
					variant="bordered"
					class=""
				>
					<template #description="{ item }">
						{{ item.description }}
						<span class="cursor-pointer text-primary">more...</span>
					</template>
				</List>
				<div class="mt-auto px-3">
					<Button
						@click.prevent="gotoLogin"
						variant="light"
						icon-right="arrowRight"
						class="cursor-pointer bg-primary/10"
						:full-width="true"
						size="lg"
					>
						Sign in
					</Button>
				</div>
			</div>

			<motion.div
				v-else
				:initial="{ opacity: 0, y: 20 }"
				:animate="{ opacity: 1, y: 0 }"
				:transition="{ duration: 0.3 }"
				class="mx-auto w-full max-w-3xl flex-1 px-5 py-5 md:px-8 md:py-8"
			>
				<Card
					variant="outline"
					class="border border-primary/20 bg-white"
				>
					<div class="flex flex-col gap-4 p-3 md:p-5">
						<div class="flex gap-4">
							<div
								class="flex min-h-12 min-w-12 items-center justify-center rounded bg-primary/10 text-primary"
							>
								<Icon
									:name="selectedItem.icon"
									size="md"
								></Icon>
							</div>
							<Typography variant="title">
								{{ selectedItem.title }}
							</Typography>
						</div>

						<Typography
							variant="body"
							class="text-justify leading-6 text-on-surface-muted md:text-lg md:leading-7"
						>
							{{ selectedItem.content }}
						</Typography>
					</div>
				</Card>
			</motion.div>
		</main>
	</motion.div>

	<!-- Floating Whatsapp button -->
	<div
		class="fixed bottom-16 left-5 z-50 rounded-full bg-success p-2 opacity-80 hover:opacity-100"
	>
		<a
			href="https://wa.me/971526497899"
			target="_blank"
			rel="noopener noreferrer"
			class="w-full h-full flex justify-center items-center"
			><svg viewBox="0 0 32 32" class="fill-white w-10 h-10">
				<path
					d=" M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.478-1.318.13-.33.244-.73.244-1.088 0-.058 0-.144-.03-.215-.1-.172-2.434-1.39-2.678-1.39zm-2.908 7.593c-1.747 0-3.48-.53-4.942-1.49L7.793 24.41l1.132-3.337a8.955 8.955 0 0 1-1.72-5.272c0-4.955 4.04-8.995 8.997-8.995S25.2 10.845 25.2 15.8c0 4.958-4.04 8.998-8.998 8.998zm0-19.798c-5.96 0-10.8 4.842-10.8 10.8 0 1.964.53 3.898 1.546 5.574L5 27.176l5.974-1.92a10.807 10.807 0 0 0 16.03-9.455c0-5.958-4.842-10.8-10.802-10.8z"
					fill-rule="evenodd"
				></path>
			</svg>
		</a>
	</div>
</template>
